import { CoreIcon } from '../core-icon';
import repairFillSVG from '../../assets/icons/repair-fill.svg';
import type { IconProps } from '../core-icon';

export const RepairFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={repairFillSVG} {...props} />;
};
